@if (activeFormProperties.length > 0) {
  <app-dynamic-form
    [formProperties]="activeFormProperties"
    [formGroup]="formGroup"
    [fieldFilterString]="searchString"
  ></app-dynamic-form>
}
